export enum TrendIndicatorType {
  Unknow,
  Up,
  Down,
}

export enum PriceIndicatorType {
  Unknown = 0,
  High = 1,
  Low = 2,
  Middle = 3,
}
